import { TFunction } from 'i18next'
import { ExcelManager } from '../../../../shared/xlsx/ExcelManager'
import { NationalContractReferenceWithTypeDto, NationalContractType } from '../../../../types'

export const NATIONAL_CONTRACT_REFERENCE_IMPORT_ALL = 'ALL' as const

export type NationalContractReferenceImportScope = typeof NATIONAL_CONTRACT_REFERENCE_IMPORT_ALL | NationalContractType

const buildSheetData = (reference: NationalContractReferenceWithTypeDto, t: TFunction): (string | number)[][] => {
  const header = [
    t('companySettingsView.nationalContractReferenceTab.editModal.columns.level'),
    t('companySettingsView.nationalContractReferenceTab.editModal.columns.currentMinSalary'),
    t('companySettingsView.nationalContractReferenceTab.editModal.columns.newMinSalary'),
  ]

  const rows = [...reference.levels]
    .sort((a, b) => b.displayOrder - a.displayOrder)
    .map((level) => [level.level, level.minSalary, ''])

  return [header, ...rows]
}

const buildTemplateFilename = (scope: NationalContractReferenceImportScope, t: TFunction): string => {
  if (scope === NATIONAL_CONTRACT_REFERENCE_IMPORT_ALL) {
    return `${t('companySettingsView.nationalContractReferenceTab.importModal.templateFilenameAll')}.xlsx`
  }

  return `${t('companySettingsView.nationalContractReferenceTab.importModal.templateFilenameSingle', {
    contractType: t(`employee.nationalContract.type.${scope}`),
  })}.xlsx`
}

export const downloadNationalContractReferenceTemplate = (
  references: NationalContractReferenceWithTypeDto[],
  scope: NationalContractReferenceImportScope,
  t: TFunction,
): void => {
  const excelManager = ExcelManager.getInstance()
  const filename = buildTemplateFilename(scope, t)

  if (scope === NATIONAL_CONTRACT_REFERENCE_IMPORT_ALL) {
    excelManager.downloadExcelWithMultipleSheets(
      filename,
      references.map((reference) => ({
        name: reference.type,
        data: buildSheetData(reference, t),
      })),
    )
    return
  }

  const reference = references.find((item) => item.type === scope)
  if (!reference) {
    return
  }

  excelManager.downloadExcel(filename, buildSheetData(reference, t), reference.type)
}
